

import axios from 'axios';
import { baseURL, CREATEUSER } from './types';
import {
  GET_ALL_DOCTORS_REQUEST,
  GET_ALL_DOCTORS_SUCCESS,
  GET_ALL_DOCTORS_FAIL,
  GET_DOCTOR_PROFILE_REQUEST,
  GET_DOCTOR_PROFILE_SUCCESS,
  GET_DOCTOR_PROFILE_FAIL,
  DOCTOR_FILTER,
  DELETE_SERVICE_REQUEST,
  DELETE_SERVICE_SUCCESS,
  DELETE_SERVICE_FAIL,
  DELETE_SPECIALIZATION_REQUEST,
  DELETE_SPECIALIZATION_SUCCESS,
  DELETE_SPECIALIZATION_FAIL,
  DELETE_REGISTRATION_FAIL,
  DELETE_REGISTRATION_SUCCESS,
  DELETE_REGISTRATION_REQUEST,
  DELETE_MEMBERSHIP_FAIL,
  DELETE_MEMBERSHIP_SUCCESS,
  DELETE_MEMBERSHIP_REQUEST,
  DELETE_AWARD_FAIL,
  DELETE_AWARD_SUCCESS,
  DELETE_AWARD_REQUEST,
  DELETE_EXPERIENCE_FAIL,
  DELETE_EXPERIENCE_SUCCESS,
  DELETE_EXPERIENCE_REQUEST,
  DELETE_EDUCATION_FAIL,
  DELETE_EDUCATION_SUCCESS,
  DELETE_EDUCATION_REQUEST,
  GET_COUPON_BY_CODE_REQUEST,
  GET_COUPON_BY_CODE_SUCCESS,
  GET_COUPON_BY_CODE_FAIL,

} from '../actions/types';

const initialState = {
  loading: false,
  doctors: [],
  error: null,
};

// 1. Profile Info
export const submitDoctorProfileInfo = (profileInfo) => async (dispatch) => {
  const token = localStorage.getItem('token');
  console.log('Token used:', token);

  dispatch({ type: 'SUBMIT_PROFILE_REQUEST' });

  const config = {
    method: 'post',
    url: `${baseURL}/api/appointmentDoctorProfileInfo/create`,
    headers: {
      // Remove manual Content-Type to let axios set the correct boundary for FormData
      // 'Content-Type': 'multipart/form-data',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    data: profileInfo, // This is FormData
  };

  try {
    const response = await axios(config);
    dispatch({ type: 'SUBMIT_PROFILE_SUCCESS', payload: response.data });
  } catch (error) {
    console.error(error.response?.data || error.message);
    dispatch({ type: 'SUBMIT_PROFILE_FAIL', payload: error.message });
  }
};




// Upload Clinic Image
export const uploadClinicImage = (formData) => async (dispatch) => {
  const token = localStorage.getItem('token');

  const config = {
    method: 'post',
    url: `${baseURL}/api/appointmentDoctorClinicImage/create`,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    data: formData,
  };

  try {
    const response = await axios(config);
    dispatch({
      type: 'UPLOAD_CLINIC_IMAGE_SUCCESS',
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: 'UPLOAD_CLINIC_IMAGE_FAIL',
      payload: error.message || 'Image upload failed',
    });
  }
};

// Services
export const submitServices = (serviceData) => async (dispatch) => {
  const token = localStorage.getItem('token');

  const config = {
    method: 'post',
    url: `${baseURL}/api/appointmentDoctorPInfoServices/create`,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    data: serviceData,
  };

  try {
    const response = await axios(config);
    dispatch({ type: 'SUBMIT_SERVICES_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'SUBMIT_SERVICES_FAIL', payload: error.message });
  }
};

// Specialization
export const submitSpecialization = (specializations) => async (dispatch) => {
  const token = localStorage.getItem('token');

  const config = {
    method: 'post',
    url: `${baseURL}/api/appointmentDoctorPInfoSpecialization/create`,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    data: specializations,
  };

  try {
    const response = await axios(config);
    dispatch({ type: 'SUBMIT_SPECIALIZATION_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'SUBMIT_SPECIALIZATION_FAIL', payload: error.message });
  }
};

// Education
export const submitEducation = (educationData) => async (dispatch) => {
  const token = localStorage.getItem('token');

  const config = {
    method: 'post',
    url: `${baseURL}/api/appointmentDoctorPInfoEducation/create`,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    data: educationData,
  };

  try {
    const response = await axios(config);
    dispatch({ type: 'SUBMIT_EDUCATION_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'SUBMIT_EDUCATION_FAIL', payload: error.message });
  }
};

// Experience
export const submitExperience = (experienceData) => async (dispatch) => {
  const token = localStorage.getItem('token');

  const config = {
    method: 'post',
    url: `${baseURL}/api/appointmentDoctorPInfoExperience/create`,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    data: experienceData,
  };

  try {
    const response = await axios(config);
    dispatch({ type: 'SUBMIT_EXPERIENCE_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'SUBMIT_EXPERIENCE_FAIL', payload: error.message });
  }
};

// Awards
export const submitAwards = (awardData) => async (dispatch) => {
  const token = localStorage.getItem('token');

  const config = {
    method: 'post',
    url: `${baseURL}/api/appointmentDoctorPInfoAwards/create`,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    data: awardData,
  };

  try {
    const response = await axios(config);
    dispatch({ type: 'SUBMIT_AWARDS_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'SUBMIT_AWARDS_FAIL', payload: error.message });
  }
};

// Memberships
export const submitMemberships = (membershipData) => async (dispatch) => {
  const token = localStorage.getItem('token');

  const config = {
    method: 'post',
    url: `${baseURL}/api/appointmentDoctorPInfoMemberships/create`,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    data: membershipData,
  };

  try {
    const response = await axios(config);
    dispatch({ type: 'SUBMIT_MEMBERSHIPS_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'SUBMIT_MEMBERSHIPS_FAIL', payload: error.message });
  }
};

// Registrations
export const submitRegistrations = (registrationData) => async (dispatch) => {
  const token = localStorage.getItem('token');

  const config = {
    method: 'post',
    url: `${baseURL}/api/appointmentDoctorPInfoRegistrations/create`,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    data: registrationData,
  };

  try {
    const response = await axios(config);
    dispatch({ type: 'SUBMIT_REGISTRATIONS_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'SUBMIT_REGISTRATIONS_FAIL', payload: error.message });
  }
};



//get all doctor



export const getAllDoctors = (filterData = {}) => async (dispatch) => {
  const token = localStorage.getItem('token');

  dispatch({ type: GET_ALL_DOCTORS_REQUEST });

  try {
    const response = await axios.post(
      `${baseURL}/api/appointmentDoctorProfileInfo/getall`,
      filterData,
      {
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      }
    );

    dispatch({
      type: GET_ALL_DOCTORS_SUCCESS,
      payload: response.data,
    });
    
  } catch (error) {
    dispatch({
      type: GET_ALL_DOCTORS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};


// Get doctor profile by ID
export const getDoctorProfileById = (hospitalID) => async (dispatch) => {
  const token = localStorage.getItem('token');
  dispatch({ type: GET_DOCTOR_PROFILE_REQUEST });

  try {
    const response = await axios.post(
      `${baseURL}/api/appointmentDoctorProfileInfo/byid`,
      { hospitalID },
      {
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      }
    );

    dispatch({
      type: GET_DOCTOR_PROFILE_SUCCESS,
      payload: response.data,  // full response data from API

    });
  } catch (error) {
    dispatch({
      type: GET_DOCTOR_PROFILE_FAIL,
      payload: error.response?.data?.message || error.message,
    });

  }
};



// This should be in your src/actions/doctorActions.js file


export const filterDoctors = (location, query) => (dispatch, getState) => {
  const { doctors } = getState().doctorList || { doctors: [] };

  if (!doctors || doctors.length === 0) {
    dispatch({
      type: DOCTOR_FILTER,
      payload: { data: [], location, query }
    });
    return;
  }

  const locationLower = location?.toLowerCase().trim() || '';
  let queryLower = query?.toLowerCase().trim() || '';

  // --- THIS IS THE FIX ---
  // First, convert the query to lowercase, THEN check for and remove the prefix.
  if (queryLower.startsWith('dr.') || queryLower.startsWith('dr ')) {
    // Find the first space and take everything after it.
    const firstSpaceIndex = queryLower.indexOf(' ');
    if (firstSpaceIndex !== -1) {
      queryLower = queryLower.substring(firstSpaceIndex + 1).trim();
    }
  }
  // --- END OF FIX ---

  const filtered = doctors.filter(doc => {
    // Step 1: Location Match (if location is provided)
    const locationMatch = locationLower
      ? (doc.CDCity?.toLowerCase().includes(locationLower))
      : true;

    if (!locationMatch) {
      return false;
    }

    // Step 2: Query Match (if query is provided)
    if (!queryLower) {
      return true; // If no query, location match is enough
    }
    
    // This comprehensive search logic will now work correctly with the cleaned query.
    const fieldsToCheck = [
      doc.id?.toString(),
      doc.hospitalID?.toString(),
      doc.username,
      doc.email,
      doc.firstName,
      doc.lastName,
      `${doc.firstName || ''} ${doc.lastName || ''}`, // Check against full name
      doc.phoneNumber,
      doc.gender,
      doc.aboutMe,
      doc.CDAddressLine1,
      doc.CDAddressLine2,
      doc.CDCity,
      doc.CDState,
      doc.CDCountry,
      doc.CDPostalCode?.toString(),
      doc.PricingOnline,
      doc.PricingOffline,
      doc.AccountStatus,
      ...(doc.Services || []).map(s => s.Services),
      ...(doc.Specializations || []).map(s => s.Specialization),
      ...(doc.Educations || []).map(e => `${e.Degree} ${e.CollegeInst} ${e.YearofCompl}`),
      ...(doc.Experiences || []).map(e => `${e.Designation} ${e.HospitalName}`),
      ...(doc.Awards || []).map(a => a.Awards),
      ...(doc.Memberships || []).map(m => m.Memberships),
      ...(doc.Registrations || []).map(r => r.Registrations)
    ].filter(Boolean);

    const queryMatch = fieldsToCheck.some(field =>
      field.toLowerCase().includes(queryLower)
    );

    return queryMatch;
  });

  dispatch({
    type: DOCTOR_FILTER,
    payload: {
      data: filtered,
      location,
      query
    }
  });
};
// Profile Info (PATCH)
// Update Doctor Profile Info
// Update Doctor Profile Info
export const updateDoctorProfileInfo = (profileInfo) => async (dispatch) => {
  const token = localStorage.getItem('token');

  const config = {
    method: 'patch',
    url: `${baseURL}/api/appointmentDoctorProfileInfo/update`,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    data: profileInfo,
  };

  try {
    const response = await axios(config);
    // Dispatch the entire updated doctor profile object, not just hospitalid
    dispatch({
      type: 'UPDATE_PROFILE_SUCCESS',
      payload: response.data, // assuming response.data contains full updated profile
    });
  } catch (error) {
    dispatch({
      type: 'UPDATE_PROFILE_FAIL',
      payload: error.message || 'Failed to update profile',
    });
  }
};



// Clinic Image upload usually remains POST (file upload)
export const updateClinicImage = (clImgData) => async (dispatch) => {
  const token = localStorage.getItem('token');
  const formData = new FormData();
  formData.append('ClinicImage', clImgData.ClinicImage.file); // image file
  formData.append('hospitalid', clImgData.hospitalID);

  const config = {
    method: 'patch',
    url: `${baseURL}/api/appointmentDoctorClinicImage/update`, // Assuming endpoint uses hospitalID in path
    headers: {
      'Content-Type': 'multipart/form-data',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    data: formData,
  };

  try {
    const response = await axios(config);
    dispatch({
      type: 'PATCH_CLINIC_IMAGE_SUCCESS',
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: 'PATCH_CLINIC_IMAGE_FAIL',
      payload: error.message || 'Image patch failed',
    });
  }
};

// Services
export const updateServices = (serviceData) => async (dispatch) => {
  const token = localStorage.getItem('token');
  const config = {
    method: 'patch',
    url: `${baseURL}api/appointmentDoctorPInfoServices/update`,
    headers: { 'Content-Type': 'application/json', ...(token && { Authorization: `Bearer ${token}` }) },
    data: serviceData,
  };
  try {
    const response = await axios(config);
    dispatch({ type: 'UPDATE_SERVICES_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'UPDATE_SERVICES_FAIL', payload: error.message });
  }
};

// Specialization
export const updateSpecialization = (specializations) => async (dispatch) => {
  const token = localStorage.getItem('token');
  const config = {
    method: 'patch',
    url: `${baseURL}/api/appointmentDoctorPInfoSpecialization/update`,
    headers: { 'Content-Type': 'application/json', ...(token && { Authorization: `Bearer ${token}` }) },
    data: specializations,
  };
  try {
    const response = await axios(config);
    dispatch({ type: 'UPDATE_SPECIALIZATION_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'UPDATE_SPECIALIZATION_FAIL', payload: error.message });
  }
};

// Education
export const updateEducation = (educationData, id) => async (dispatch) => {
  const token = localStorage.getItem('token');
  const config = {
    method: 'patch',
    url: `${baseURL}/api/appointmentDoctorPInfoEducation/update`,
    headers: { 'Content-Type': 'application/json', ...(token && { Authorization: `Bearer ${token}` }) },
    data: educationData,
  };
  try {
    const response = await axios(config);
    dispatch({ type: 'UPDATE_EDUCATION_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'UPDATE_EDUCATION_FAIL', payload: error.message });
  }
};

// Experience
export const updateExperience = (experienceData, id) => async (dispatch) => {
  const token = localStorage.getItem('token');
  const config = {
    method: 'patch',
    url: `${baseURL}/api/appointmentDoctorPInfoExperience/update`,
    headers: { 'Content-Type': 'application/json', ...(token && { Authorization: `Bearer ${token}` }) },
    data: experienceData,
  };
  try {
    const response = await axios(config);
    dispatch({ type: 'UPDATE_EXPERIENCE_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'UPDATE_EXPERIENCE_FAIL', payload: error.message });
  }
};

// Awards
export const updateAwards = (awardData, id) => async (dispatch) => {
  const token = localStorage.getItem('token');
  const config = {
    method: 'patch',
    url: `${baseURL}/api/appointmentDoctorPInfoAwards/update`,
    headers: { 'Content-Type': 'application/json', ...(token && { Authorization: `Bearer ${token}` }) },
    data: awardData,
  };
  try {
    const response = await axios(config);
    dispatch({ type: 'UPDATE_AWARDS_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'UPDATE_AWARDS_FAIL', payload: error.message });
  }
};

// Memberships
export const updateMemberships = (membershipData, id) => async (dispatch) => {
  const token = localStorage.getItem('token');
  const config = {
    method: 'patch',
    url: `${baseURL}/api/appointmentDoctorPInfoMemberships/update`,
    headers: { 'Content-Type': 'application/json', ...(token && { Authorization: `Bearer ${token}` }) },
    data: membershipData,
  };
  try {
    const response = await axios(config);
    dispatch({ type: 'UPDATE_MEMBERSHIPS_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'UPDATE_MEMBERSHIPS_FAIL', payload: error.message });
  }
};

// Registrations
export const updateRegistrations = (registrationData) => async (dispatch) => {
  console.log("updateRegistrations called with:", registrationData);

  const token = localStorage.getItem('token');
  const config = {
    method: 'patch',
    url: `${baseURL}/api/appointmentDoctorPInfoRegistrations/update`,
    headers: { 'Content-Type': 'application/json', ...(token && { Authorization: `Bearer ${token}` }) },
    data: registrationData,
  };
  try {
    const response = await axios(config);
    dispatch({ type: 'UPDATE_REGISTRATIONS_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'UPDATE_REGISTRATIONS_FAIL', payload: error.message });
  }
};




// doctorActions.js
export const deleteClinicImage = (imageId, hospitalID) => async (dispatch) => {
  const token = localStorage.getItem('token');
  try {
    await axios.delete(`${baseURL}/api/appointmentDoctorClinicImage/delete`, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        'Content-Type': 'application/json',
      },
      data: {
        id: imageId,
        hospitalID: hospitalID,
      },
    });

    dispatch({ type: 'DELETE_CLINIC_IMAGE_SUCCESS', payload: imageId });
  } catch (error) {
    dispatch({
      type: 'DELETE_CLINIC_IMAGE_FAIL',
      payload: error.message || 'Failed to delete clinic image',
    });
  }
};


// Delete Service action
export const deleteService = (serviceId, hospitalID) => async (dispatch) => {
  dispatch({ type: DELETE_SERVICE_REQUEST });
  const token = localStorage.getItem('token');
  try {
    // Backend expects DELETE with JSON body containing id and hospitalID
    await axios.delete(`${baseURL}/api/appointmentDoctorPInfoServices/delete`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: { id: serviceId, hospitalID },
    });
    dispatch({ type: DELETE_SERVICE_SUCCESS, payload: serviceId });
  } catch (error) {
    dispatch({
      type: DELETE_SERVICE_FAIL,
      payload: error.response?.data?.message || error.message || 'Failed to delete service',
    });
  }
};

// Delete Specialization action
export const deleteSpecialization = (specializationId, hospitalID) => async (dispatch) => {
  dispatch({ type: DELETE_SPECIALIZATION_REQUEST });
  const token = localStorage.getItem('token');
  try {
    await axios.delete(`${baseURL}/api/appointmentDoctorPInfoSpecialization/delete`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: { id: specializationId, hospitalID },
    });
    dispatch({ type: DELETE_SPECIALIZATION_SUCCESS, payload: specializationId });
  } catch (error) {
    dispatch({
      type: DELETE_SPECIALIZATION_FAIL,
      payload: error.response?.data?.message || error.message || 'Failed to delete specialization',
    });
  }
};


export const deleteEducation = (educationId, hospitalID) => async (dispatch) => {
  dispatch({ type: DELETE_EDUCATION_REQUEST });
  const token = localStorage.getItem('token');
  try {
    await axios.delete(`${baseURL}/api/appointmentDoctorPInfoEducation/delete`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: { id: educationId, hospitalID },
    });
    dispatch({ type: DELETE_EDUCATION_SUCCESS, payload: educationId });
  } catch (error) {
    dispatch({
      type: DELETE_EDUCATION_FAIL,
      payload: error.response?.data?.message || error.message || 'Failed to delete education',
    });
  }
};


export const deleteExperience = (experienceId, hospitalID) => async (dispatch) => {
  dispatch({ type: DELETE_EXPERIENCE_REQUEST });
  const token = localStorage.getItem('token');
  try {
    await axios.delete(`${baseURL}/api/appointmentDoctorPInfoExperience/delete`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: { id: experienceId, hospitalID },
    });
    dispatch({ type: DELETE_EXPERIENCE_SUCCESS, payload: experienceId });
  } catch (error) {
    dispatch({
      type: DELETE_EXPERIENCE_FAIL,
      payload: error.response?.data?.message || error.message || 'Failed to delete experience',
    });
  }
};


export const deleteAward = (awardId, hospitalID) => async (dispatch) => {
  dispatch({ type: DELETE_AWARD_REQUEST });
  const token = localStorage.getItem('token');
  try {
    await axios.delete(`${baseURL}/api/appointmentDoctorPInfoAwards/delete`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: { id: awardId, hospitalID },
    });
    dispatch({ type: DELETE_AWARD_SUCCESS, payload: awardId });
  } catch (error) {
    dispatch({
      type: DELETE_AWARD_FAIL,
      payload: error.response?.data?.message || error.message || 'Failed to delete award',
    });
  }
};


export const deleteMembership = (membershipId, hospitalID) => async (dispatch) => {
  dispatch({ type: DELETE_MEMBERSHIP_REQUEST });
  const token = localStorage.getItem('token');
  try {
    await axios.delete(`${baseURL}/api/appointmentDoctorPInfoMemberships/delete`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: { id: membershipId, hospitalID },
    });
    dispatch({ type: DELETE_MEMBERSHIP_SUCCESS, payload: membershipId });
  } catch (error) {
    dispatch({
      type: DELETE_MEMBERSHIP_FAIL,
      payload: error.response?.data?.message || error.message || 'Failed to delete membership',
    });
  }
};


export const deleteRegistration = (registrationId, hospitalID) => async (dispatch) => {
  dispatch({ type: DELETE_REGISTRATION_REQUEST });
  const token = localStorage.getItem('token');
  try {
    await axios.delete(`${baseURL}/api/appointmentDoctorPInfoRegistrations/delete`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: { id: registrationId, hospitalID },
    });
    dispatch({ type: DELETE_REGISTRATION_SUCCESS, payload: registrationId });
  } catch (error) {
    dispatch({
      type: DELETE_REGISTRATION_FAIL,
      payload: error.response?.data?.message || error.message || 'Failed to delete registration',
    });
  }
};



// Add these functions to your src/actions/doctorActions.js file

// Coupon
export const submitCoupon = (couponData) => async (dispatch) => {
  const token = localStorage.getItem('token');

  const config = {
    method: 'post',
    url: `${baseURL}/api/appointementDoctorCoupons/create`, // Assuming this is your API endpoint for creating coupons
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    data: couponData,
  };

  try {
    const response = await axios(config);
    dispatch({ type: 'SUBMIT_COUPON_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'SUBMIT_COUPON_FAIL', payload: error.message });
  }
};

// Update Coupon
export const updateCoupon = (couponData) => async (dispatch) => {
  const token = localStorage.getItem('token');
  
  const config = {
    method: 'patch',
    url: `${baseURL}/api/appointementDoctorCoupons/update`, // Assuming this is your API endpoint for updating coupons
    headers: { 
      'Content-Type': 'application/json', 
      ...(token && { Authorization: `Bearer ${token}` }) 
    },
    data: couponData,
  };

  try {
    const response = await axios(config);
    dispatch({ type: 'UPDATE_COUPON_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'UPDATE_COUPON_FAIL', payload: error.message });
  }
};

// Delete Coupon
export const deleteCoupon = (couponId, hospitalID) => async (dispatch) => {
  // NOTE: You will need to define DELETE_COUPON_REQUEST, SUCCESS, FAIL in your types.js
  dispatch({ type: 'DELETE_COUPON_REQUEST' }); 
  const token = localStorage.getItem('token');
  
  try {
    await axios.delete(`${baseURL}/api/appointementDoctorCoupons/delete`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: { id: couponId, hospitalID }, // Pass data in the config for DELETE requests
    });
    
    dispatch({ type: 'DELETE_COUPON_SUCCESS', payload: couponId });
    
  } catch (error) {
    dispatch({
      type: 'DELETE_COUPON_FAIL',
      payload: error.response?.data?.message || error.message || 'Failed to delete coupon',
    });
  }
};



export const getCouponByCode = (couponCode, hospitalID) => async (dispatch) => {
  // Dispatch a request action, useful for showing loading spinners in the UI.
  dispatch({ type: GET_COUPON_BY_CODE_REQUEST });
  
  const token = localStorage.getItem('token');

  const config = {
    method: 'get',
    // We use a "verify" or "lookup" endpoint. The coupon code and hospitalID
    // are sent as URL query parameters, which is standard for GET requests.
    url: `${baseURL}/api/coupons/verify`,
    headers: {
      // 'Content-Type' is not needed for GET requests with no body.
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    // For GET requests, parameters are passed in a `params` object.
    // Axios will convert this to: ?code=...&hospitalID=...
    params: {
      code: couponCode,
      hospitalID: hospitalID,
    }
  };

  try {
    const response = await axios(config);
    
    // On success, dispatch the coupon data to the Redux store.
    dispatch({ 
        type: GET_COUPON_BY_CODE_SUCCESS, 
        payload: response.data 
    });
    
    // Return the successful response so the calling component can use it directly.
    return response.data;

  } catch (error) {
    // Extract a user-friendly error message from the server response.
    const errorMessage = error.response?.data?.message || 'Invalid or expired coupon code.';
    
    dispatch({ 
        type: GET_COUPON_BY_CODE_FAIL, 
        payload: errorMessage 
    });
    
    // Propagate the error, allowing the component's .catch() block to handle it.
    return Promise.reject(new Error(errorMessage));
  }
};